import { ChartDimensions } from '/src/lib/types';

/**
 * Dimensions
 */

export type DimensionsProps = ChartDimensions;

export class Dimensions implements DimensionsProps {
  width: number;
  height: number;

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
  }
}
